import { FC } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useToastStore } from '../../stores';

const Toast: FC = () => {
	const { toastProps, setToast } = useToastStore();

	const handleClose = () => {
		setToast({ message: '', variant: toastProps.variant });
	};

	return (
		<Snackbar
			open={!!toastProps.message}
			autoHideDuration={5000}
			onClose={handleClose}
			anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
		>
			<Alert
				onClose={handleClose}
				severity={toastProps.variant}
				variant='filled'
				sx={{ width: '100%' }}
			>
				{toastProps.message}
			</Alert>
		</Snackbar>
	);
};

export default Toast;
